"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripInvalidUserLanguagePreferences = exports.validateUserLanguagePreferences = void 0;
const types_1 = require("@fluent-forever/types");
const R = __importStar(require("ramda"));
const PartialLanguagePreferencesSchema = types_1.UserLanguagePreferencesSchema.partial();
const validateUserLanguagePreferences = (preferences) => PartialLanguagePreferencesSchema.safeParse(preferences);
exports.validateUserLanguagePreferences = validateUserLanguagePreferences;
const stripInvalidUserLanguagePreferences = (preferences) => {
    var _a;
    if (!preferences) {
        return {};
    }
    const result = exports.validateUserLanguagePreferences(preferences);
    if (result.success) {
        return result.data;
    }
    const issues = (_a = result.error) === null || _a === void 0 ? void 0 : _a.flatten();
    const validationResult = exports.validateUserLanguagePreferences(R.omit(Object.keys(issues.fieldErrors), preferences));
    return validationResult.success ? validationResult.data : {};
};
exports.stripInvalidUserLanguagePreferences = stripInvalidUserLanguagePreferences;
//# sourceMappingURL=user_language_preferences_utils.js.map